import { useMutation } from '@tanstack/react-query';

import { RequestConfig } from '~/common/services/requests/types/RequestConfig';
import { Envelope } from '../../../../types';
import { handleError } from '../../../../utils/admin';
import { DocumentParams } from '../../../documents/types/DocumentParams';
import { useRequestConstructor } from '../../../hooks/useRequestConstructor';
import { sendEnvelope } from '../../requests/sendEnvelope';

type SendEnvelopeVariables = {
  envelopeId: string;
  documentParams: DocumentParams<'definition'>;
  params?: RequestConfig['params'];
};

type SendEnvelopeOptions = {
  onError?: () => void;
};

export const useSendEnvelope = (options?: SendEnvelopeOptions) => {
  const { constructGet } = useRequestConstructor();

  const { mutateAsync, ...rest } = useMutation<
    Envelope | undefined,
    Error,
    SendEnvelopeVariables
  >({
    mutationFn: ({ envelopeId, documentParams, params }) =>
      sendEnvelope(constructGet, envelopeId, documentParams, params).then(
        (response) => response?.data,
      ),
    onError: () => {
      if (options?.onError) {
        options.onError();
      } else {
        handleError('Failed to send envelope.');
      }
    },
  });

  return { sendEnvelope: mutateAsync, ...rest };
};
